module.exports = __webpack_public_path__ + "b605bcc5f7495793717134c5416459c8.svg";